import { SaveOutlined } from "@ant-design/icons";
import { useFormik } from "formik";
import React, { useState, useEffect } from "react";
import { showError, showSuccess, trimData } from "../../../utils/utilities";
import ParkAuto from "../../../services/api/ParkAuto";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { Col, Input, InputNumber, Row, Select, Spin } from "antd";
import { carCategory } from "../../../utils/properties";
import CarEngineType from "../../../services/api/CarEngineType";
import Button from "../../../components/functional_components/Button/PFButton";

const { Option } = Select;

const ParkAutoData = ({ parkAuto, setFatherState, fatherState }) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    loading: false,
    carEngineTypes: [],
  });

  useEffect(() => {
    getCarEngineTypes();
  }, []);

  const formikParkAuto = useFormik({
    initialValues: {
      brand: get(parkAuto, "brand", null),
      calcKm: get(parkAuto, "calcKm", null),
      category: get(parkAuto, "category", null),
      cc: get(parkAuto, "cc", null),
      carEngineType: get(parkAuto, "carEngineType.id", null),
      model: get(parkAuto, "model", null),
      plate: get(parkAuto, "plate", null),
      powerKw: get(parkAuto, "powerKw", null),
    },
    validate: (values) => {
      values = trimData(values);
      let errors = {};
      if (!values.brand) {
        errors.brand = "Required!";
      }
      if (!values.calcKm) {
        errors.calcKm = "Required!";
      }
      if (!values.category) {
        errors.category = "Required!";
      }
      if (!values.cc) {
        errors.cc = "Required!";
      }
      if (!values.carEngineType) {
        errors.carEngineType = "Required!";
      }
      if (!values.model) {
        errors.model = "Required!";
      }
      if (!values.plate) {
        errors.plate = "Required!";
      }
      if (!values.powerKw) {
        errors.powerKw = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      setState((prevState) => ({ ...prevState, loading: true }));
      const data = {
        ...values,
        carEngineType: state.carEngineTypes.find((c) => c.id === values.carEngineType),
        id: parkAuto?.id || undefined,
      };
      const saveResponse = await ParkAuto.setParkAuto(data);
      if (!saveResponse.error) {
        showSuccess();
        setFatherState((prevState) => ({ ...prevState, refreshParkAuto: !fatherState.refreshParkAuto }));
      } else {
        showError(get(saveResponse, "error.messageCode", "ER000"));
      }
      setState((prevState) => ({ ...prevState, loading: false }));
    },
  });
  const getCarEngineTypes = async () => {
    let carEngineTypes = {};
    setState((prevState) => ({ ...prevState, loading: true }));
    const { data: dataEngine, error: errorEngine } = await CarEngineType.getCarEngineTypes("allPages=true");
    if (!errorEngine && dataEngine) {
      carEngineTypes = dataEngine;
    } else {
      showError(get(errorEngine, "messageCode", "ER000"));
    }
    setState((prevState) => ({ ...prevState, loading: false, carEngineTypes }));
  };
  return (
    <>
      {state.loading ? (
        <div className="container-spinner-positioning">
          <Spin spinning={state.loading} className="spinner-positioning" />
        </div>
      ) : (
        ""
      )}
      <Row gutter={[40, 24]} justify="space-around">
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="id">
              {t("parkAuto.table.category")}*
            </label>
          </Row>
          <Row>
            <Select
              allowClear
              className="w-100"
              id="category"
              name="category"
              onChange={(value) => formikParkAuto.setFieldValue("category", value)}
              placeholder={t("parkAuto.table.category")}
              onBlur={formikParkAuto.handleBlur("category")}
              value={formikParkAuto.values.category}
            >
              {carCategory.map((data, idx) => (
                <Option key={idx} value={data}>
                  {t(`carCategory.${data}`)}
                </Option>
              ))}
            </Select>
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="plate">
              {t("parkAuto.table.plate")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="plate"
              name="plate"
              placeholder={t("parkAuto.table.plate")}
              onChange={formikParkAuto.handleChange}
              onBlur={formikParkAuto.handleBlur}
              value={formikParkAuto.values.plate}
            />
          </Row>
        </Col>
      </Row>
      <Row gutter={[40, 24]} justify="space-around">
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="brand">
              {t("parkAuto.table.brand")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="brand"
              name="brand"
              onChange={formikParkAuto.handleChange}
              onBlur={formikParkAuto.handleBlur}
              value={formikParkAuto.values.brand}
            />
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="model">
              {t("parkAuto.table.model")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="model"
              name="model"
              onChange={formikParkAuto.handleChange}
              onBlur={formikParkAuto.handleBlur}
              value={formikParkAuto.values.model}
            />
          </Row>
        </Col>
      </Row>
      <Row gutter={[40, 24]} justify="space-around">
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="carEngineType">
              {t("parkAuto.table.carEngineType")}*
            </label>
          </Row>
          <Row>
            <Select
              allowClear
              className="w-100"
              id="carEngineType"
              name="carEngineType"
              onChange={(value) => formikParkAuto.setFieldValue("carEngineType", value)}
              placeholder={t("parkAuto.table.carEngineType")}
              onBlur={formikParkAuto.handleBlur("carEngineType")}
              value={formikParkAuto.values.carEngineType}
            >
              {state.carEngineTypes.map((data, idx) => (
                <Option key={idx} value={data.id}>
                  {data.name}
                </Option>
              ))}
            </Select>
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="calcKm">
              {t("parkAuto.table.calcKm", { um: parkAuto.carEngineType?.efficiencyDesc })}*
            </label>
          </Row>
          <Row>
            <InputNumber
              className="ant-input"
              controls={false}
              required
              id="calcKm"
              name="calcKm"
              placeholder={t("parkAuto.table.calcKm", { um: parkAuto.carEngineType?.efficiencyDesc })}
              onChange={(e) => formikParkAuto.setFieldValue("calcKm", e)}
              onBlur={formikParkAuto.handleBlur}
              value={formikParkAuto.values.calcKm}
              precision={2}
              decimalSeparator=","
            />
          </Row>
        </Col>
      </Row>
      <Row gutter={[40, 24]} justify="space-around">
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="cc">
              {parkAuto.carEngineType?.measurementDesc}*
            </label>
          </Row>
          <Row>
            <InputNumber
              className="ant-input"
              controls={false}
              required
              id="cc"
              name="cc"
              onChange={(e) => formikParkAuto.setFieldValue("cc", e)}
              onBlur={formikParkAuto.handleBlur}
              value={formikParkAuto.values.cc}
              precision={2}
              decimalSeparator=","
            />
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="powerKw">
              {t("parkAuto.table.powerKw")}*
            </label>
          </Row>
          <Row>
            <InputNumber
              className="ant-input"
              controls={false}
              required
              id="powerKw"
              name="powerKw"
              onChange={(e) => formikParkAuto.setFieldValue("powerKw", e)}
              onBlur={formikParkAuto.handleBlur}
              value={formikParkAuto.values.powerKw}
              precision={2}
              decimalSeparator=","
            />
          </Row>
        </Col>
      </Row>
      <Row justify="end" className="mt-1em">
        <Button
          key="okButton"
          currentIcon={<SaveOutlined className="icon-medium" />}
          clickCallback={formikParkAuto.submitForm}
          isDisabled={!(formikParkAuto.dirty && formikParkAuto.isValid)}
        />
      </Row>
    </>
  );
};

export default ParkAutoData;
